"use strict";

var _AsyncBoundary, _AuthProvider;
import { createClient } from '@autoguru/auth';
import { AuthProvider } from '@autoguru/auth/react-auth';
import { getToken } from '@autoguru/auth/relay';
import { SectionLoading } from '@autoguru/components';
import { EnvironmentProvider, createEnvironment } from '@autoguru/relay';
import { AsyncBoundary } from '@autoguru/suspense';
import { FleetClientPortalHomeRoutes } from '~/src/pages';
import { jsx as _jsx } from "react/jsx-runtime";
const authClient = createClient();
const relayModernEnvironment = createEnvironment({
  fetcherOptions: {
    getToken
  }
});
const AppHome = () => {
  return _AsyncBoundary || (_AsyncBoundary = /*#__PURE__*/_jsx(AsyncBoundary, {
    fallback: null,
    children: /*#__PURE__*/_jsx(FleetClientPortalHomeRoutes, {})
  }));
};
export const App = () => _AuthProvider || (_AuthProvider = /*#__PURE__*/_jsx(AuthProvider, {
  allow_socials: true,
  client: authClient,
  children: /*#__PURE__*/_jsx(AsyncBoundary, {
    fallback: SectionLoading,
    children: /*#__PURE__*/_jsx(EnvironmentProvider, {
      environment: relayModernEnvironment,
      children: /*#__PURE__*/_jsx(AppHome, {})
    })
  })
}));